import { format } from 'date-fns'
import { differenceInMinutes } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { DateTime } from 'luxon'

export const getActualEta = (eta: any) => {
  if (isNaN(Math.floor(eta))) {
    return 0
  } else {
    switch (eta) {
      case null:
      case undefined:
      case 99:
        return 0
      default:
        return eta
    }
  }
}

const statusEta = (bookedDate: Date, etaSeconds: number, timeZone: string) => {
  const newEta = Math.ceil(etaSeconds / 60)
  const dateNow = new Date()
  const statusEta = new Date(dateNow.setMinutes(dateNow.getMinutes() + newEta))

  if (statusEta.getTime() === bookedDate.getTime()) {
    try {
      return format(utcToZonedTime(bookedDate, timeZone), 'H:mm')
    } catch {
      return ''
    }
  }
  const diffInMinutes = differenceInMinutes(statusEta, bookedDate)
  const label = diffInMinutes === 1 ? ' min)' : ' mins)'
  if (bookedDate.getTime() > statusEta.getTime()) {
    try {
      return `${format(
        utcToZonedTime(bookedDate, timeZone),
        'H:mm',
      )} (${diffInMinutes}${label}`
    } catch {
      return ''
    }
  }

  if (bookedDate.getTime() < statusEta.getTime()) {
    try {
      return `${format(
        utcToZonedTime(bookedDate, timeZone),
        'H:mm',
      )} (+${diffInMinutes}${label}`
    } catch {
      return ''
    }
  }
}

export const expectedArrivalStatusDisplay = (
  status: string | undefined,
  bookedDate: Date,
  etaSeconds: number,
  timeZone: string,
) => {
  switch (status) {
    case 'Confirmed':
    case 'Driver_Allocated':
      try {
        return format(utcToZonedTime(bookedDate, timeZone), 'H:mm')
      } catch {
        return ''
      }
    case 'OnRoute':
      return statusEta(bookedDate, etaSeconds, timeZone)
    default:
      return ''
  }
}

export function expectedArrivalDisplay(
  journeyStatus: string,
  when?: Date,
  etaMinutes?: number,
  etaSeconds?: number,
  timeZone?: string,
) {
  if (!when || when === undefined) {
    return undefined
  }

  //ETA
  const actualEta = getActualEta(etaMinutes)
  const dateWhen = new Date(when)
  const bookedDate = new Date(
    dateWhen.setMinutes(dateWhen.getMinutes() + actualEta),
  )

  if (etaSeconds === undefined) {
    return format(bookedDate, 'dd/MM/yy : H:mm')
  }
  return expectedArrivalStatusDisplay(
    journeyStatus,
    bookedDate,
    etaSeconds,
    timeZone ? timeZone : 'Europe/London',
  )
}

export const bookedTimeWithEta = (bookedDate: DateTime, eta: number) => {
  const newTime = DateTime.fromISO(bookedDate.toString())
    .plus({ minutes: getActualEta(eta) })
    .toISO()
  return newTime
}

export default expectedArrivalDisplay
